<template>
    <div>
        <div v-if="userAuth" class="useful-container position-relative me-2">
            <a :id="'usefulTrigger' + uniqueId" @mouseover="visible = true" @mouseleave="visible = false" class="usefulTrigger teal" @click="voteUseful">
                <span class="icon utile" :class="modelType === 'review' || modelType === 'book' ? 'utile' : 'smile'"></span>
                <span v-model="usefulCount">{{ modelType === 'review' || modelType === 'book' ? 'Utile' : 'Smile'}} {{ usefulCount > 0 ? '(' + usefulCount + ')' : '' }}</span>
            </a><span v-if="message"> - {{ this.message }}</span>

            <p v-model="voters" :id="'useful' + uniqueId" class="useful-box useful-box-position text-center p-2 mb-0" :class="(visible && usefulCount > 0) ? '' : 'hide'">
                {{ voters }}
            </p>
        </div>

        <div v-else class="useful-container position-relative me-2">
            <a :id="'usefulTrigger' + uniqueIdPart1 + uniqueIdPart2" v-model="usefulCount" @mouseover="visible = true" @mouseleave=" visible = false" class="usefulTrigger teal" data-bs-toggle="modal" data-bs-target="#connexion">
                <span class="icon utile" :class="modelType === 'review' || modelType === 'book' ? 'utile' : 'smile'"></span>
                <span v-model="usefulCount">{{ modelType === 'review' || modelType === 'book' ? 'Utile' : 'Smile'}} {{ usefulCount > 0 ? '(' + usefulCount + ')' : '' }}</span>
            </a>

            <p v-model="voters" :id="'useful' + uniqueId" class="useful-box useful-box-position text-center p-2 mb-0 text-capitalize" :class="(visible && usefulCount > 0) ? '' : 'hide'">
                {{ voters }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        uniqueIdPart1: Number,
        uniqueIdPart2: Number,
        uniqueIdPart3: Number,
        usefulCount: Number,
        modelType: String,
        modelId: Number,
        receiverId: Number,
        profileId: Number,
        giverId: Number,
        userAuth: Boolean,
        votersUseful: String,
    },

    data() {
        return {
            message: null,
            uniqueId: null,
            visible : false,
            voters: null,
        }
    },

    mounted() {
        this.voters = this.votersUseful;
        this.uniqueId = this.uniqueIdPart3 ? `${this.uniqueIdPart3}${this.uniqueIdPart1}${this.uniqueIdPart2}` : `${this.uniqueIdPart1}${this.uniqueIdPart2}`;
    },

    methods: {
        voteUseful() {
            axios.post('/api/v1/vote/useful',
                {
                    giverId: this.giverId,
                    modelId: this.modelId,
                    modelType: this.modelType,
                    profileId: this.profileId,
                    receiverId: this.receiverId
                })
                .then((response) => {
                    this.voters = response.data.names;
                    this.usefulCount = response.data.count;
                    this.message = response.data.message;
                })
                .catch((error) => {
                    console.log('Erreur ! ' + error);
                })
        },
    }
};
</script>
